import * as React from "react";
import FlowType from "../commons/model/FlowType";

namespace ReportTypeUtils {
  export function getTypeComponent(item?: FlowType, sharingButton?) {
    const lightColor = getReportTypeColor(item, 0.1);
    return (
      <>
        {item && (
          <div className={"label-container" + (sharingButton ? " flex-center space-between" : "" )}>
            <span
              className="label report-type-column"
              style={{
                color: getReportTypeColor(item),
                borderColor: lightColor,
                backgroundColor: lightColor,
              }}
            >
              <span>{i18n[getReportTypeI18nKey(item)]}</span>
            </span>
            {sharingButton && (sharingButton)}
          </div>
        )}
      </>
    );
  }

  export const getReportTypeI18nKey = function (type: FlowType) {
    switch (type) {
      case FlowType.FULL_ASSESSMENT:
        return "Global.Reports.Type.FullAssessment";
      case FlowType.SMILE_ASSESSMENT:
        return "Global.Reports.Type.SmileAssessment";
      case FlowType.SMILE_SIMULATION:
        return "Global.Reports.Type.SmileSimulation";
    }
  };

  export const getReportTypeColor = function (type: FlowType, opacity?: number) {
    switch (type) {
      case FlowType.FULL_ASSESSMENT:
        return `rgba(231, 140, 35, ${opacity || 1})`;
      case FlowType.SMILE_ASSESSMENT:
        return `rgba(35, 130, 231, ${opacity || 1})`;
      case FlowType.SMILE_SIMULATION:
        return `rgba(159, 130, 241, ${opacity || 1})`;
    }
  };
}

export default ReportTypeUtils;
